import { Type } from 'class-transformer';
import {
  IsIn,
  IsString,
  IsNotEmpty,
  Min,
  IsInt,
  IsOptional,
} from 'class-validator';

import { FilterType } from '@vk-hr-tek/core/filter';

export class GetWidgetsContentDto {
  @Min(0)
  @IsInt()
  @Type(() => Number)
  @IsOptional()
  offset = 0;

  @Min(1)
  @IsInt()
  @Type(() => Number)
  @IsOptional()
  // eslint-disable-next-line no-magic-numbers
  limit = 12;

  @IsIn(['account', 'company'])
  @IsString()
  @IsNotEmpty()
  scope_type: 'account' | 'company' = 'account';

  filters?: FilterType;
}
